/**
 * businessConfig.service.ts — Frontera de datos para la configuración del negocio.
 *
 * Centraliza la configuración usada por tickets y permite sustituir la
 * persistencia local por una API sin modificar componentes.
 */
import {
  runTransaction,
  txRead,
  txWrite,
} from "@/lib/persistence/transactionalStore";
import type { StoredBusinessConfig } from "../utils/businessConfigStorage";

const STORAGE_KEY = "businessConfig";

export const businessConfigService = {
  get<T extends Partial<StoredBusinessConfig>>(defaults: T): T {
    return {
      ...defaults,
      ...txRead<Partial<StoredBusinessConfig>>(STORAGE_KEY, {}),
    };
  },

  save<T extends StoredBusinessConfig>(config: T): void {
    txWrite(STORAGE_KEY, config);
  },

  update(
    updater: (current: StoredBusinessConfig) => StoredBusinessConfig,
  ): StoredBusinessConfig {
    return runTransaction(() => {
      const current = txRead<StoredBusinessConfig>(STORAGE_KEY, {
        nombre: "Mi negocio",
        pais: "CO",
        direccion: "",
        nit: "",
      });
      const next = updater(current);
      txWrite(STORAGE_KEY, next);
      return next;
    });
  },
};
